<template>
	<div class="panel-layout">
		<ClientOnly>
			<div v-if="!isTablet_sm" class="panel-layout__container">
				<AdminDrawer />
				<div class="panel-layout__content">
					<slot />
				</div>
			</div>
			<div v-else class="panel-layout__container">
				<GlobalMobileNoComponent />
			</div>
		</ClientOnly>
	</div>
</template>

<script setup lang="ts">
const { isTablet_sm } = useWindowWidth()

// const adminPanelStore = useAdminPanelStore()
// const route = useRoute()

// watchEffect(() => {
// 	if (route.path.includes('panel/product-catalog')) adminPanelStore.setActiveTab('Katalog pojazdów')
// 	if (route.path.includes('panel/parameters')) adminPanelStore.setActiveTab('Parametry')
// })
// useHead({
// 	link: [
// 		{ rel: 'apple-touch-icon', sizes: '180x180', href: '/apple-touch-icon.png' },
// 		{ rel: 'icon', type: 'image/png', sizes: '32x32', href: '/favicon-32x32.png' },
// 		{ rel: 'icon', type: 'image/png', sizes: '16x16', href: '/favicon-16x16.png' },
// 		{ rel: 'manifest', href: '/site.webmanifest' },
// 		{ rel: 'mask-icon', href: '/safari-pinned-tab.svg', color: '#5bbad5' },
// 		{ rel: 'shortcut icon', href: '/favicon.ico' },
// 	],
// })
</script>

<style lang="scss" src="./panel.scss"></style>
